import React from 'react';
import { CommonError } from '@trv/pa-components-react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
    Begin,
    CallUs,
    ConfirmPolicies,
    ContactInformation,
    CreateProfile,
    SessionTimeout,
    SystemUnavailable,
    TermsConditions
} from '../pages';

export default function AppRoutes() {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            {/*<ScrollToTop>*/}
            <Routes>
                <Route exact path="/" element={<Begin />} />
                <Route exact path="/terms-conditions" element={<TermsConditions />} />
                <Route exact path="/policies" element={<ConfirmPolicies />} />
                <Route exact path="/contact-info" element={<ContactInformation />} />
                <Route exact path="/call-us" element={<CallUs />} />
                <Route exact path="/profile" element={<CreateProfile />} />
                <Route exact path="/timeout" element={<SessionTimeout />} />
                <Route element={<SystemUnavailable />} />
                <Route exact path="/error" element={<CommonError />} status={404} />
                <Route exact path="*" element={<SystemUnavailable />} />
                <Route exact path="/timeout" element={<SessionTimeout />} />
            </Routes>

            {/*</ScrollToTop>*/}
        </Router>
    );
}
